import { useEffect, useState } from 'react'
import { useDispatch } from 'react-redux'
import { setRouterObjAction } from '../../modules/homedata'
import {
  MainMenuKey,
  mainMenuTypeDictInvert,
  RoleMenu,
  userRouter,
} from '../../route'
import {
  CheckLocalStorage,
  decodeAuthToken,
  GetLocalStorage,
} from '../../tools/util'
import { useTypedSelector } from '../../redux/store'
import { useGlobalData } from '@/stores/appStore'
import ArmsRum from '@arms/rum-browser'
import { ENABLE_ARMS } from '@/global/config'

function whenIsLogin(callback: () => void) {
  if (CheckLocalStorage('SRM_TOKEN')) {
    callback()
  }
}
export function useSetupHook() {
  const mainRouterList = userRouter[1].router

  const dispatchApp = useDispatch()
  const homeState = useTypedSelector((state) => state.homeData)
  const { loginInfo } = homeState

  const [updateNotice, setUpdateNotice] = useState<boolean>(false)

  const { loadGlobalData } = useGlobalData()
  // 打开更新通知弹框
  const openUpdateNotice = () => {
    setUpdateNotice(true)
  }
  // 关闭更新通知弹框
  const closeUpdateNotice = () => {
    setUpdateNotice(false)
  }
  type RouteDict = {
    [key in MainMenuKey]: any[]
  }
  function applyMenuPermission(routerObj: RouteDict) {
    const menuPermissions: string[] = GetLocalStorage('MENU_LIST')
    const newRouterObj: RouteDict = {
      基本信息: [],
      物料管理: [],
      询报价: [],
      订单管理: [],
      客户开票: [],
      开票付款: [],
      系统管理: [],
    }
    for (const [key, value] of Object.entries(routerObj) as [
      MainMenuKey,
      any,
    ]) {
      if (key === '系统管理') {
        newRouterObj[key as MainMenuKey] = routerObj?.[
          key as MainMenuKey
        ]?.filter((item) => {
          return (
            menuPermissions.includes(item.key) ||
            ['member', 'accout'].includes(item.key)
          )
        })
        continue
      }
      newRouterObj[key as MainMenuKey] = routerObj?.[
        key as MainMenuKey
      ]?.filter((item) => {
        return menuPermissions.includes(item.key)
      })
    }
    return newRouterObj
  }
  const InitRouterObj = () => {
    const enTypeKey = Object.keys(mainMenuTypeDictInvert)
    const routerObj: RouteDict = {
      基本信息: [],
      物料管理: [],
      询报价: [],
      订单管理: [],
      客户开票: [],
      开票付款: [],
      系统管理: [],
    }
    try {
      const token = GetLocalStorage('SRM_TOKEN')
      const info = decodeAuthToken(token)
      try {
        if (ENABLE_ARMS) {
          const originConfig: any = ArmsRum.getConfig()
          const newConfig = {
            ...originConfig,
            user: {
              ...originConfig.user,
              name: `userId:${info.userId}`,
            },
          }
          ArmsRum.setConfig(newConfig)
        }
      } catch (error) {
        // eslint-disable-next-line no-console
        console.error('ARMS set conifg failed:', error)
      }
      const rolemenu = RoleMenu(info.role)
      mainRouterList?.forEach((item) => {
        if (!rolemenu.includes(item.key)) {
          return
        }
        const typeKey: any = item?.type ?? 'ddsaklj'
        if (enTypeKey.includes(typeKey)) {
          routerObj[mainMenuTypeDictInvert[typeKey] as MainMenuKey].push(item)
        }
      })
      const newRouterObj = applyMenuPermission(routerObj)
      dispatchApp(setRouterObjAction(newRouterObj))
    } catch (error) {
      console.error(error)
    }
  }
  useEffect(() => {
    InitRouterObj()
    whenIsLogin(() => {
      loadGlobalData()
    })
    setUpdateNotice(loginInfo?.isFirst ? true : false)
    // eslint-disable-next-line
  }, [])

  return { updateNotice, openUpdateNotice, closeUpdateNotice }
}
import { useEffect, useState } from 'react'
import { useDispatch } from 'react-redux'
import { setRouterObjAction } from '../../modules/homedata'
import {
  MainMenuKey,
  mainMenuTypeDictInvert,
  RoleMenu,
  userRouter,
} from '../../route'
import {
  CheckLocalStorage,
  decodeAuthToken,
  GetLocalStorage,
} from '../../tools/util'
import { useTypedSelector } from '../../redux/store'
import { useGlobalData } from '@/stores/appStore'
import ArmsRum from '@arms/rum-browser'
import { ENABLE_ARMS } from '@/global/config'

function whenIsLogin(callback: () => void) {
  if (CheckLocalStorage('SRM_TOKEN')) {
    callback()
  }
}
export function useSetupHook() {
  const mainRouterList = userRouter[1].router

  const dispatchApp = useDispatch()
  const homeState = useTypedSelector((state) => state.homeData)
  const { loginInfo } = homeState

  const [updateNotice, setUpdateNotice] = useState<boolean>(false)

  const { loadGlobalData } = useGlobalData()
  // 打开更新通知弹框
  const openUpdateNotice = () => {
    setUpdateNotice(true)
  }
  // 关闭更新通知弹框
  const closeUpdateNotice = () => {
    setUpdateNotice(false)
  }
  type RouteDict = {
    [key in MainMenuKey]: any[]
  }
  function applyMenuPermission(routerObj: RouteDict) {
    const menuPermissions: string[] = GetLocalStorage('MENU_LIST')
    const newRouterObj: RouteDict = {
      基本信息: [],
      物料管理: [],
      询报价: [],
      订单管理: [],
      客户开票: [],
      开票付款: [],
      系统管理: [],
    }
    for (const [key, value] of Object.entries(routerObj) as [
      MainMenuKey,
      any,
    ]) {
      if (key === '系统管理') {
        newRouterObj[key as MainMenuKey] = routerObj?.[
          key as MainMenuKey
        ]?.filter((item) => {
          return (
            menuPermissions.includes(item.key) ||
            ['member', 'accout'].includes(item.key)
          )
        })
        continue
      }
      newRouterObj[key as MainMenuKey] = routerObj?.[
        key as MainMenuKey
      ]?.filter((item) => {
        return menuPermissions.includes(item.key)
      })
    }
    return newRouterObj
  }
  const InitRouterObj = () => {
    const enTypeKey = Object.keys(mainMenuTypeDictInvert)
    const routerObj: RouteDict = {
      基本信息: [],
      物料管理: [],
      询报价: [],
      订单管理: [],
      客户开票: [],
      开票付款: [],
      系统管理: [],
    }
    try {
      const token = GetLocalStorage('SRM_TOKEN')
      const info = decodeAuthToken(token)
      try {
        if (ENABLE_ARMS) {
          const originConfig: any = ArmsRum.getConfig()
          const newConfig = {
            ...originConfig,
            user: {
              ...originConfig.user,
              name: `userId:${info.userId}`,
            },
          }
          ArmsRum.setConfig(newConfig)
        }
      } catch (error) {
        // eslint-disable-next-line no-console
        console.error('ARMS set conifg failed:', error)
      }
      const rolemenu = RoleMenu(info.role)
      mainRouterList?.forEach((item) => {
        if (!rolemenu.includes(item.key)) {
          return
        }
        const typeKey: any = item?.type ?? 'ddsaklj'
        if (enTypeKey.includes(typeKey)) {
          routerObj[mainMenuTypeDictInvert[typeKey] as MainMenuKey].push(item)
        }
      })
      const newRouterObj = applyMenuPermission(routerObj)
      dispatchApp(setRouterObjAction(newRouterObj))
    } catch (error) {
      console.error(error)
    }
  }
  useEffect(() => {
    InitRouterObj()
    whenIsLogin(() => {
      loadGlobalData()
    })
    setUpdateNotice(loginInfo?.isFirst ? true : false)
    // eslint-disable-next-line
  }, [])

  return { updateNotice, openUpdateNotice, closeUpdateNotice }
}
